import type { ReactNode } from 'react';
import { copyText } from '@/lib/clipboard';
import { Icon } from './Icon';

// A secret shown once (a new person's password): big enough to read, a button to copy, what to do with it.
export function Secret(props: {
    title: string;
    value: string;
    note: ReactNode;
    onCopied: (message: string) => void;
    onClose: () => void;
}): ReactNode {
    return (
        <div className="panel secret">
            <div className="sheet-head">
                <div>
                    <h2>{props.title}</h2>
                    <p>Shown once: keep it now.</p>
                </div>
                <button className="closebtn" onClick={props.onClose} title="I have kept it">
                    <Icon name="x" size={17} />
                </button>
            </div>
            <div className="secret-body">
                <div className="secret-value">
                    <code>{props.value}</code>
                    <button
                        className="act primary"
                        onClick={() => {
                            void copyText(props.value).then(() => props.onCopied('Copied'));
                        }}
                    >
                        <Icon name="copy" size={15} /> Copy
                    </button>
                </div>
                <div className="secret-note">{props.note}</div>
            </div>
        </div>
    );
}
